// PA Account Settings (doctor) — PROD-1817.
//
// Now a thin wrapper over the ported dev-scrips-pm-react `PractitionerEditPage`.
// PA previously maintained its own page + 8 tab bodies; those are superseded by
// the port and removed.
//
// WHY THIS IS NOT AN ADMIN SURFACE — the distinction PROD-1719 turns on:
// `PractitionerEditPage` already ships the self-edit mode PM built for exactly
// this (`accountMode`, its own doc: "The logged-in practitioner edits their OWN
// record. Set by AccountSettingsRoute, never by the admin list routes"). In
// account mode the id comes from the auth user via `idOverride`, NOT from a
// `:doctorSetupId` route param, so there is no way to reach somebody else's
// record from PA — PA never mounts the admin list routes that would supply one.
//
// Mirrors Flutter `base_screen.dart`: DoctorBaseWidget(isFromAccountSettings: true).
import { PractitionerEditPage } from './components/practitioner-edit/practitioner-edit-page';

export interface AccountSettingsPageProps {
  /** The logged-in practitioner's own setup-record GUID (`user.id`). */
  doctorSetupId: string;
}

export function AccountSettingsPage({ doctorSetupId }: AccountSettingsPageProps) {
  return <PractitionerEditPage mode="edit" accountMode idOverride={doctorSetupId} />;
}
